import React from 'react'

const InProcess = () => {
  return (
    <div className="inprocess">InProcess</div>
  )
}

export default InProcess